import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import humanizeString from '../../utils'
import { useIsAdmin, useIsSuperAdmin, useMobileStore } from '../../store';
import { apiClient } from '../../api_actions/index';
import { Modal, Select, Space, Input } from 'antd';
import React, { useState, useEffect } from 'react';
import './Locations.scss';

export default function LocationsPage() {
  const isSuperAdmin = useIsSuperAdmin();
  const isMobile = useMobileStore((state) => state.isMobile);
  const [searchInput, setSearchInput] = useState('');
  const { Search } = Input;
  
  const columns = [
    {
      title: 'Location Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    //{ title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Latitude', dataIndex: 'latitude', key: 'latitude' },
    { title: 'Longitude', dataIndex: 'longitude', key: 'longitude' },
    { title: 'Timezone', dataIndex: 'time_zone', key: 'time_zone' },
  ];

  const formFields = [
    {
      name: 'location_id',
      label: 'Location ID',
      type: 'textarea',
      placeholder: 'Location ID',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'Location Name',
      rules: [{ required: true, message: 'Must Enter a Location Name!' }]
    },
    {
      name: 'latitude',
      label: 'Latitude',
      type: 'number',
      step: 0.1,         // Allow one decimal
      precision: 7,      // Show one decimal place
      min: -180,
      max: 180,
      rules: [{ required: true, message: 'Must Enter a Latitude!' }]
    },
    {
      name: 'longitude',
      label: 'Longitude',
      type: 'number',
      step: 0.1,         // Allow one decimal
      precision: 7,      // Show one decimal place
      min: -180,
      max: 180,
      rules: [{ required: true, message: 'Must Enter a Longitude!' }]
    },
    {
      name: 'time_zone',
      label: 'TimeZone',
      type: 'select',
      placeholder: 'Select TimeZone',
      options: [
        { label: 'EST', value: 'est' },
        { label: 'CST', value: 'cst' },
      ],
      rules: [{ required: true, message: 'Must Select a TimeZone!' }]
    }
  ];

  return (
    <div className='container-wrapper'>
      <div>
        <h2>Locations</h2>
      </div>
      <div className={`locations-filter-wrapper ${isSuperAdmin ? 'admin-margin' : ''}`}>
        <div className="locations-filter-controls">
          {(<label className="locations-filter-label">Filter by:</label>)}
          {React.createElement(isMobile ? React.Fragment : Space.Compact, {},
            (
              <Search
                placeholder="Location Name..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            )
          )}
        </div>
      </div>

      <ModalEditTable
        createEndpoint="create/locations"
        readEndpoint="read/locations"
        editEndpoint="update/locations"
        deleteEndpoint="delete/locations"
        searchQuery="location_name"
        searchInput={searchInput}
        columns={columns}
        formFields={formFields}
      />
    </div>
  );
}